module.exports = __webpack_public_path__ + "img/ico-sav.18b0f92c.svg";